import { useDispatch, useSelector } from "react-redux";

import "./TopicPicker.css";
import { startGame } from "../../../redux/features/authSlice";
import { setNewsie } from "../../../redux/features/gameSlice";
import { NEWSIE_CATEGORIES, SHOW_TOPIC_PUZZLES } from "../../../util/constants";

const MAIN_GAME = NEWSIE_CATEGORIES[0];

export const TOPIC_LABELS: Record<string, string> = {
  sports: "🏅 Sports",
  entertainment: "🎞️ Entertainment",
  science: "🔬 Science",
  world: "🌎 World",
  politics: "🇺🇸 Politics",
  business: "💰 Business",
  uplifting: "🙂 Uplifting",
  weird: "🤯 Weird",
};

// Shareable path for a topic, e.g. newsie.fyi/sports
const topicPath = (category: string) => (category === MAIN_GAME ? "/" : `/${category}`);

const TopicPicker = ({ isLoggedIn }) => {
  const dispatch = useDispatch();
  const allNewsies = useSelector((state: any) => state.gameReducer.allNewsies);
  const selectedNewsie = useSelector((state: any) => state.gameReducer.selectedNewsie);
  const gameOver = useSelector((state: any) => state.gameReducer.gameOver);

  const play = (e, category: string) => {
    e.stopPropagation();
    if (!allNewsies?.[category]?.length) return;
    if (category !== selectedNewsie) dispatch(setNewsie(category));
    // Keep the URL shareable without remounting the app
    window.history.replaceState(null, "", topicPath(category));
    dispatch(startGame());
  };

  const mainDone = Boolean(gameOver?.[MAIN_GAME]);
  const topics = SHOW_TOPIC_PUZZLES ? Object.keys(TOPIC_LABELS).filter((c) => allNewsies?.[c]?.length) : [];
  // A /sports link lands here with sports preselected, so lead with it
  const featured = SHOW_TOPIC_PUZZLES && selectedNewsie !== MAIN_GAME && TOPIC_LABELS[selectedNewsie] ? selectedNewsie : MAIN_GAME;

  const mainLabel =
    featured === MAIN_GAME
      ? mainDone
        ? "See today's results"
        : isLoggedIn
        ? "Play today's Newsie"
        : "Play as a Guest"
      : `Play today's ${TOPIC_LABELS[featured]} Newsie`;

  return (
    <div className="topic-picker">
      <div className="landing-page-play-button-container">
        <div className="landing-page-play-button" onClick={(e) => play(e, featured)}>
          {mainLabel}
        </div>
      </div>
      {topics.length > 0 && (
        <>
          <div className="topic-picker-heading">More puzzles today</div>
          <div className="topic-picker-grid">
            {featured !== MAIN_GAME && (
              <button className="topic-picker-chip" onClick={(e) => play(e, MAIN_GAME)}>
                📰 Top stories
                {mainDone && <span className="topic-picker-check">✓</span>}
              </button>
            )}
            {topics
              .filter((c) => c !== featured)
              .map((c) => (
                <button key={c} className="topic-picker-chip" onClick={(e) => play(e, c)}>
                  {TOPIC_LABELS[c]}
                  {gameOver?.[c] && <span className="topic-picker-check">✓</span>}
                </button>
              ))}
          </div>
        </>
      )}
    </div>
  );
};

export default TopicPicker;
